import { useCallback, useMemo } from "react"

import { ensureArray } from "shared/lib/arrayUtils"

import { TabBarRootProps } from "../TabBar"
import { TabBarContextType } from "../context/TabBarContext"

export function useTabBarViewModel({
  activeKey,
  onSelect,
  ...containerProps
}: Omit<TabBarRootProps, "children" | "enableSort" | "onSort">) {
  const normalizedActiveKeys = useMemo(
    () => ensureArray(activeKey),
    [activeKey]
  )

  const isSelected = useCallback(
    (eventKey: string) => normalizedActiveKeys.includes(eventKey),
    [normalizedActiveKeys]
  )

  const onTabSelect = useCallback(
    (eventKey: string) => {
      if (normalizedActiveKeys.includes(eventKey)) return
      onSelect?.(eventKey)
    },
    [onSelect, normalizedActiveKeys]
  )

  const context: TabBarContextType = useMemo(
    () => ({
      activeKeys: normalizedActiveKeys,
      isSelected,
      onTabSelect,
      hoverIndex: null
    }),
    [normalizedActiveKeys, isSelected, onTabSelect]
  )

  return { context, containerProps, isSelected }
}
